import axios from 'axios';
import {
  FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST,
  FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS,
  FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE
} from './currentYearUIDTypes';

export const fetchCurrentYearStudentUIDs = () => async (dispatch) => {
  dispatch({ type: FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST });
  try {
    const response = await axios.get('http://localhost/epro_API/api/students/get/currentUIDS.php'); // Replace with your API
    dispatch({ type: FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE, error: error.message });
  }
};
